export const ITEMS_VOLUME_INPUT_MAX_VALUE = 100000;
export const ITEMS_VOLUME_INPUT_MIN_VALUE = 1;
